import script from "./VipMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./VipMobile.vue?vue&type=script&setup=true&lang=js"

import "./VipMobile.vue?vue&type=style&index=0&id=1854379c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1854379c"]])

export default __exports__